import { render, staticRenderFns } from "./CouponInfoCard.vue?vue&type=template&id=af4a72d6&scoped=true"
import script from "./CouponInfoCard.vue?vue&type=script&lang=js"
export * from "./CouponInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4a72d6",
  null
  
)

export default component.exports